if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cartNotification = document.querySelector('cart-notification');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      const submitButton = this.querySelector('[type="submit"]');
      if (submitButton.classList.contains('loading')) return;

      this.handleErrorMessage();
      this.cartNotification.setActiveElement(document.activeElement);

      submitButton.setAttribute('aria-disabled', true);
      submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      formData.append('sections', this.cartNotification.getSectionsToRender().map((section) => section.id));
      formData.append('sections_url', window.location.pathname);
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);
            return;
          }

          this.cartNotification.renderContents(response);
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          submitButton.classList.remove('loading');
          submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}

$(document).on('ready', function() {

  // $('.kd-image-icon').hover(function() {
  //   variant_id = this.id.split('variant-').join('');
  //   $('#' + variant_id).toggleClass('kd-image-overlay');
  // });

  /* Variant click overlay js */
  $('.kd-image-icon').on('click', function() {
    variant_id = this.id.split('variant-').join('');
    $(this).parents('li.kd-grid__item').children('.kd-grid__item--image').children('.kd-grid__item-link').children('.kd-image-variant').removeClass('kd-image-overlay');
    $('#' + variant_id).addClass('kd-image-overlay');
    $(this).parents('li.kd-grid__item').children('.kd-grid__item--details').children('.kd-grid__item--product-info').children('.kd-product-info__price').children('.kd-info__price').hide();
    $(this).parents('li.kd-grid__item').children('.kd-grid__item--details').children('.kd-grid__item--product-info').children('.kd-product-info__price').children('#kd-info__variant-price-'+variant_id).show();
  });


  /* custom best selling section mobile slider */
  const init = {
    autoplay: false,
    infinite: true,
    cssEase: "linear",
    slidesToShow: 1,
    slidesToScroll: 1 };

  $(() => {
    const win = $(window);
    const slider = $(".kd-section--best-selling-products"); 

    win.on("load resize", () => {
      if($(document).find(".kd-section--best-selling-products").length > 0 && $(document).find(".kd-grid__item").length > 1 && !jQuery_11(document).find('.mymilk-best-selling-section').length){
        if (win.width() < 767) {        
          slider.not(".slick-initialized").slick(init);
        } else if (slider.hasClass("slick-initialized")) {
          slider.slick("unslick");
        }
      }      
    });
  });


  /* equalheight for collection page products & best selling custom section */
  equalheight = function(container){
    var currentTallest = 0,
    currentRowStart = 0,
    rowDivs = new Array(),
    $el,
    topPosition = 0;


    $(container).each(function() {
      $el = $(this);
      $($el).height('auto')
      topPostion = $el.position().top;

      if (currentRowStart != topPostion) {
        for (currentDiv = 0 ; currentDiv < rowDivs.length ; currentDiv++) {
          rowDivs[currentDiv].height(currentTallest);
        }
        rowDivs.length = 0; // empty the array
        currentRowStart = topPostion;
        currentTallest = $el.height();
        rowDivs.push($el);
      } else {
        rowDivs.push($el);
        currentTallest = (currentTallest < $el.height()) ? ($el.height()) : (currentTallest);
      }
      for (currentDiv = 0 ; currentDiv < rowDivs.length ; currentDiv++) {
        rowDivs[currentDiv].height(currentTallest);
      }
    });
  }

  $(window).load(function() {
    equalheight('#kd-product-grid .kd-grid__item .kd-grid__item--details');
    // equalheight('.kd-blog-box-container .kd-blog-box-wrapper');
  });

  $(window).resize(function(){
    equalheight('#kd-product-grid .kd-grid__item .kd-grid__item--details');
    // equalheight('.kd-blog-box-container .kd-blog-box-wrapper');
  });

});

class QuantityInputCustom extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true })
    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }
  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;
    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
}
customElements.define('quantity-input-custom', QuantityInputCustom);